/**
 * TimelineView — dedicated view for project timeline visualization.
 *
 * Single integrated component: accordion labels as the left column,
 * Gantt chart bars as the right column.  Scrolls as one unit.
 */

import { useMemo } from 'react';
import { useAdjacencyStore } from '../../store/adjacency-store';
import { nodePassesFilter } from '../../utils/filter-nodes';
import { TimelineGantt } from './TimelineGantt';

export function TimelineView() {
  const nodes = useAdjacencyStore((s) => s.nodes);
  const filters = useAdjacencyStore((s) => s.filters);

  const filteredNodes = useMemo(
    () => nodes.filter((n) => nodePassesFilter(n, filters)),
    [nodes, filters],
  );

  return (
    <div className="flex-1 min-h-0 overflow-auto">
      <TimelineGantt nodes={filteredNodes} allNodes={nodes} />
    </div>
  );
}
